<template>
  <div class="chat_right">
    <div class="chat_right_top pointer">
      <!-- <span class="chat_nav_label active">客户相关</span> -->
      <span
        v-for="(item,index) in tabList"
        :key="index"
        :class="{'active': tabIndex == index}"
        class="chat_nav_label"
        @click="tabChange(index)"
      >{{ item }}</span>
    </div>
    <div class="overflow_style heigth_90">
      <div class="chat_right_shoplist">
        <div
          v-show="tabIndex===0"
          class="chat_right_title"
        >
          <span class="shoplist">来往订单</span>
          <router-link :to="{name: 'orderList'}">
            <span class="more pointer">更多 ></span>
          </router-link>
        </div>
        <ul
          v-show="tabIndex===0"
          class="order_list"
        >
          <li
            v-if="orderList.length==0"
            class="no_order"
          >
            <img
              src="http://img.yimutian.com/misc/5cc693716ef1434e6e5651b02459a0ef.png"
              alt=""
            >
            <p>暂无订单</p>
          </li>
          <li
            v-for=" (item,index) in orderList"
            :key="index"
            class="chat_people pointer"
          >
            <div class="order_info">
              <div class="shopimg">
                <img
                  :src="item.product_img | aspectFit(44, 44)"
                  alt
                >
              </div>
              <div class="shopcontent">
                <span class="content">{{ item.product_name }}</span>
                <span class="content">实付 ¥{{ (item.cost/100).toFixed(2) }}</span>
              </div>
            </div>
            <div class="order_status">
              <span class="date">{{ item.date }}</span>
              <span
                class="status"
                v-html="item.order_status_text"
              />
            </div>
          </li>
        </ul>
        <ul
          v-show="tabIndex===1"
          class="order_list"
        >
          <li
            v-if="supplyList.length==0"
            class="no_order no_supply"
          >
            <img
              src="http://img.yimutian.com/misc/5cc693716ef1434e6e5651b02459a0ef.png"
              alt=""
            >
            <p>暂无供应</p>
          </li>
          <li
            v-for=" (item,index) in supplyList"
            :key="index"
            class="chat_people pointer"
          >
            <div class="order_info">
              <div class="shopimg">
                <img
                  :src="item.cover_image | aspectFit(44, 44)"
                  alt
                >
              </div>
              <div class="shopcontent">
                <span class="content">{{ item.title }}</span>
                <span class="content">{{ item.price }}{{ item.unit }}</span>
              </div>
            </div>
            <div class="order_status">
              <!-- <span class="payment"><button
                class="chat_right_btn global_btn"
                @click="showDialog(index)"
              >付款单</button></span> -->
              <!-- <span class="space" /> -->
              <span class="order_link"><button
                class="chat_right_btn global_btn"
                @click="sendLink(item)"
              >供应链接</button></span>
              <!-- <div
                v-if="paymentIndex===index"
                class="payment_dialog"
              >
                <div class="payment_dialog_content">
                  <div class="dialog_value">
                    <div class="dialog_label">
                      购买数量
                    </div>
                    <div class="input">
                      <input
                        v-model.number="buy_volume"
                        type="number"
                        class="input_normal"
                        placeholder="0"
                        @input="checkInput($event,1)"
                      >
                    </div>
                    <div class="daiwei">
                      {{ item.unit_id | getUnitName }}
                    </div>
                  </div>
                  <div class="dialog_value">
                    <div class="dialog_label">
                      总金额
                    </div>
                    <div class="input">
                      <input
                        v-model.number="total_cost"
                        type="number"
                        class="input_normal"
                        placeholder="0"
                        @input="checkInput($event,2)"
                      >
                    </div>
                    <div class="daiwei">
                      元
                    </div>
                  </div>
                  <div class="sku_value">
                    <span
                      v-for="(sku_item,index) in item.supplies_sku"
                      :key="index"
                      :class="{'active': index==skuIndex}"
                      @click="selectSku(index)"
                    >{{ sku_item.title }}</span>
                  </div>
                </div>
                <div class="payment_dialog_remark">
                  <p>总金额是买家需要支付给您的全部费用，包括代办费，小工费/包装费，运费，打冷费</p>
                </div>
                <div class="payment_dialog_foot">
                  <button
                    class="chat_right_btn global_btn"
                    @click="cancel"
                  >
                    取消
                  </button>
                  <span class="space" />
                  <button
                    :class="{active: check}"
                    class="chat_right_btn global_btn"
                    @click="confirm"
                  >
                    确认
                  </button>
                </div>
              </div> -->
            </div>
          </li>
        </ul>
      </div>
      <div
        v-show="tabIndex===0"
        class="chat_right_callhistoryList"
      >
        <div class="chat_right_title">
          <span class="shoplist">历史通话</span>
        </div>
        <ul class="recent_call">
          <li
            v-for="(item, index) in callRecordList"
            :key="index"
          >
            <span class="content">来自 {{ item.call_reason }}</span>
            <span
              v-if="item.call_status==1"
              class="icon"
            ><img
              src="http://img.yimutian.com/misc/5cc694446ef1434e6e56524ee67b6a17.png"
              alt=""
            ></span>
            <span class="time">{{ item.call_time*1000 | formatTime('yyyy/M/d hh:mm:ss') }}</span>
          </li>
          <li
            v-show="callRecordList.length===0"
            class="no_record"
          >
            <img
              src="http://img.yimutian.com/misc/5cc6934d6ef1434e6e56519cd4ef1dc1.png"
              alt=""
            >
            <p>暂无历史通话</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { chat, orderList } from '@/api.js'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      tabList: ['客户相关', '我的供应'],
      tabIndex: 0,
      orderList: [],
      supplyList: [],
      paymentIndex: null,
      skuIndex: 0,
      showDialogFlag: false,
      callRecordList: [],
      buy_volume: '',
      total_cost: '',
      check: false,
      user_name: ''
    }
  },
  computed: {
    ...mapState('chat', [
      'peer_uid',
      'dialog_id',
      'customer_id',
      'tipsTimestamp'
    ])
  },
  watch: {
    peer_uid() {
      this.getOrderList()
      this.callRecord()
    },
    tipsTimestamp() {
      setTimeout(() => {
        this.getOrderList()
      }, 200)
    }
  },
  created() {
    if (this.peer_uid) {
      this.getOrderList()
      this.callRecord()
    }
    this.getSupplyList()
  },
  methods: {
    ...mapActions('chat',
      ['historyMsg']
    ),
    tabChange(value) {
      this.tabIndex = value
    },
    // 我的供应
    getSupplyList() {
      chat.supplyList({ on_sale: 1, start: 0, page_size: 100, is_show_popup: 0 }).then(({ data: res }) => {
        if (res.status === 0) {
          this.supplyList = res.list
        }
      })
    },
    // 来往订单
    getOrderList() {
      chat.orderList({
        access_token: 'accessToken',
        client_time: new Date().getTime(),
        data: {
          customer_id: Number(this.customer_id), // 分页加载角标
          sku_type: 0,
          conversation_id: this.peer_uid,
          index: 0,
          count: 10 // 分页时， 每页的数量
        }
      }).then(({ data: res }) => {
        if (res.status === 0 && res.payload.order_list) {
          this.orderList = res.payload.order_list.slice(0, 5)
        }
      })
    },
    showDialog(index) {
      // this.paymentIndex = index 禁用web下单
    },
    cancel() {
      this.reset()
    },
    reset() {
      this.skuIndex = 0
      this.paymentIndex = null
      this.buy_volume = ''
      this.total_cost = ''
      this.check = false
    },
    confirm() {
      this.createOrder()
    },
    // 通话记录
    callRecord() {
      chat.callRecord({ customer_id: this.peer_uid, index: 0, page_size: 100 }).then(res => {
        if (res.data.status === 0) {
          this.callRecordList = res.data.result
          this.user_name = res.data.user_info.user_name
        }
      })
    },
    // 供应链接
    sendLink(item) {
      this.send('', 6, item)
    },
    selectSku(value) {
      this.skuIndex = value
    },
    // 获得sku_id
    getSkuId(value, index) {
      return value.supplies_sku[index] && value.supplies_sku[index].supplies_sku_id
    },
    getSkuTitle(value, index) {
      return value.supplies_sku[index] && value.supplies_sku[index].title
    },
    checkInput(e, type) {
      if (type === 1) {
        e.target.value = (e.target.value.match(/^[0-9]*[1-9][0-9]*$/) && e.target.value.match(/^[0-9]*[1-9][0-9]*$/)[0]) || null
        this.buy_volume = e.target.value
      } else {
        e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g) || (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0])) || null
        this.total_cost = e.target.value
      }
      if (this.buy_volume > 0 && this.total_cost > 0) {
        this.check = true
      } else {
        this.check = false
      }
    },
    createOrder() {
      let index = this.paymentIndex
      let skuIndex = this.skuIndex
      let curList = this.supplyList[index]
      if (!this.buy_volume) {
        return this.$message('请输入采购数量')
      }
      if (!this.total_cost) {
        return this.$message('请输入订单总额')
      }
      chat.createOrder({
        access_token: 'accessToken',
        payload: {
          // 通用字段
          trading_info_id: curList.supply_id, // 供应id(spu_id)
          supplies_sku_id: this.getSkuId(curList, skuIndex) || 0, // sku_id
          buy_volume: Number(this.buy_volume), // 采购数量
          buy_price: Number(curList.price) * 100, // 采购单价
          volume_unit: Number(curList.unit_id), // 价格单位
          trading_info_type: 3, // 订单发起方式 1：供应 2：报价 3：聊天 4： 拿样订单 5：拼单 6：活动方案 7：直播卖货 8：分阶段付款
          payment_option: 6, // 付款方式：6，一次性付款 7，分阶段付款
          total_cost: Number(this.total_cost) * 100, // 可选，订单总额，分为单位
          customer_id: Number(this.peer_uid)
        }
      }).then(({ data: res }) => {
        if (res.status === 0) {
          this.send(res.payload, 9, curList)
        } else if (res.status === -1) {
          this.$message(res.popup.pop_payload.sub_title || res.popup.pop_payload.title)
        }
      })
    },
    send(payload, type, item) {
      let index = this.paymentIndex
      let skuIndex = this.skuIndex
      let curList = this.supplyList[index]
      let param = {
        'peer_uid': this.peer_uid, // 收听方用户id
        'peer_type': 0, // 1 or 0(0标识peer_uid为customer_id,1标识peer_uid为shop_clients的id
        'dialog_id': this.dialog_id,
        'message_content': '', // 消息内容
        'type': type, // 消息类型：1-文字 2-图片 3-语音 4-附件 5-小视频
        'service_source': 'crm', // 见service_source字段描述
        'object_id': '', // service_source对应的id：例如采购id，供应id。。。
        'sequence': '', // 消息序列标示
        'meta': {} // 消息的额外信息
      }
      if (type === 9) {
        param.meta = {
          'amount': Number(this.buy_volume),
          'order_cost': payload.cost,
          'order_id': payload.order_id,
          'product_name': item.title,
          'product_spec': this.getSkuTitle(curList, skuIndex),
          'unit': item.unit_id,
          'version': 1
        }
        param.message_content = '[快捷订单]'
      }
      if (type === 6) {
        param.meta = {
          'product_id': 0,
          'supply_id': item.supply_id,
          'product_img': item.cover_image,
          'product_name': item.title,
          'product_spec': '',
          'price': Number(item.price),
          'price_unit': item.unit_id,
          'version': 1
        }
        param.message_content = '[商品]'
      }
      param.meta = JSON.stringify(param.meta)
      this.$store.dispatch('chat/send', param)
        .then((res) => {
          this.reset()
          let msg = {
            'content': param.message_content,
            'action_time': res.action_time,
            'msg_type': type,
            'is_mine': 1,
            'meta': param.meta,
            'id': res.id,
            'img_prefix_url': 'http://http://img.yimutian.com/',
            'customer_id': res.stream_data.cid,
            'status': 1
          }
          this.$store.dispatch('chat/updateHistoryMsg', msg).then(() => {
            this.messageValue = ''
          })
        })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/orderList.less';
</style>
